import { render, staticRenderFns } from "./SentSimpleIcon.vue?vue&type=template&id=5bb0970e&scoped=true&"
import script from "./SentSimpleIcon.vue?vue&type=script&lang=ts&"
export * from "./SentSimpleIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb0970e",
  null
  
)

export default component.exports